export const usersTableWidths = {
  users: 350,
  role: 200,
  email: 260,
  store: 300,
  addedOn: 698
}